import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const SettingsNoteBox = (props) => {
  const { t } = useTranslation();

  let jwt = localStorage.getItem("JWT");
  let link = localStorage.getItem("link");

  let data = props.data;

  const [text, setText] = useState("");

  function updateText() {
    const dataRequest = {
      remark: text,
      elementIds: data.ids,
    };

    axios
      .put(link + "/api/Lot/Remark", dataRequest, {
        headers: {
          Authorization: "Bearer " + jwt,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {})

      .catch((error) => {});
  }

  useEffect(() => {
    if (data.remark != undefined) {
      setText(data.remark);
    }
  }, [props.data]);

  return (
    <div className="settings-groups">
      <div className="settings-name">{t("allgemein.hinweis")}</div>
      <textarea
        className="textarea"
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      {/* no save button for other types than Area */}
      <button class="button" style={{ marginTop: "10px" }} onClick={updateText}>
        {" "}
        {t("allgemein.speichern")}
      </button>
    </div>
  );
};

export default SettingsNoteBox;
